import { closeWidget } from 'actions/main';
import { useAppDispatch, useAppSelector } from 'hooks';
import { clearConversation } from 'persistence/useClearConversationOnTimeout';
import { useCallback } from 'react';
import {
  selectLiveChatIntegration,
  setLiveChatStatus,
} from 'reducers/live-chat/index';
import { selectIsSolveConfigPreview } from 'reducers/workflows';

export const useHandleConversationResolved = () => {
  const dispatch = useAppDispatch();
  const isSolveConfigPreview = useAppSelector(selectIsSolveConfigPreview);
  const liveChatIntegration = useAppSelector(selectLiveChatIntegration);

  /*
  Delay is needed on cases where conversation is resolved and no CSAT is not enabled,
  this is to give time for the last message to be displayed before closing the widget.
  */
  return useCallback(
    (shouldDelay?: boolean) => {
      const executeCallback = () => {
        dispatch(clearConversation());
        if (!isSolveConfigPreview) {
          dispatch(closeWidget());
        }
      };

      if (liveChatIntegration === 'sunco') {
        dispatch(setLiveChatStatus('inactive'));
        return;
      }

      if (shouldDelay) {
        setTimeout(executeCallback, 3000);
      } else {
        executeCallback();
      }
    },
    [isSolveConfigPreview, dispatch, liveChatIntegration],
  );
};
